module.exports = __webpack_public_path__ + "f1a1359716c1d6b3e2642a41a4e2b23a.pdf";